// extracted by mini-css-extract-plugin
module.exports = {"row":"row--3j2e5","name":"name--3nba4","footerLink":"footerLink--zh-J8","col":"col--13Vn8"};